import React from 'react';
import { useTranslation } from 'react-i18next';
import { Popup } from '_atoms';
import './styles.scss';

interface PopupAssignToMeProps {
  open: boolean;
  onOk: () => void;
  onClose: () => void;
  candidateName: string;
}

export const PopupAssignToMe: React.FC<PopupAssignToMeProps> = ({ open, onOk, onClose, candidateName }) => {
  const { t } = useTranslation();

  return (
    <Popup
      className="popup-reassign-recruiter-recruiter"
      open={open}
      title={t('translation:popup_assign_to_me.title')}
      cancelButtonProps={{ onClick: onClose, children: t('translation:popup_assign_to_me.cancel') }}
      okButtonProps={{ onClick: onOk, children: t('translation:popup_assign_to_me.reassign') }}
    >
      {t('translation:popup_assign_to_me.subtitle', {
        name: candidateName,
      } as Record<string, unknown>)}
    </Popup>
  );
};
